"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.run = exports.DEFAULT_OPTS = void 0;
const FinishedChart = __importStar(require("../finished-chart"));
const Schedule = __importStar(require("../schedule"));
const Task = __importStar(require("../task"));
const TaskQueue = __importStar(require("../task-queue"));
exports.DEFAULT_OPTS = {
    task: { verbose: false },
    schedule: { verbose: false },
};
function run(schedule, opts = exports.DEFAULT_OPTS) {
    var _a, _b;
    while (true) {
        if ((_a = opts.schedule) === null || _a === void 0 ? void 0 : _a.verbose) {
            console.log(Schedule.repr(schedule));
        }
        const task = TaskQueue.dequeue(schedule.queue);
        if (task === undefined)
            return;
        if ((_b = opts.task) === null || _b === void 0 ? void 0 : _b.verbose) {
            console.log(Task.finished_p(task) ? "[resume from]:" : "   [stepping]:", Task.repr(task));
        }
        if (Task.finished_p(task)) {
            Schedule.resume(schedule, task);
            FinishedChart.insert(schedule.finished_chart, task);
        }
        else {
            Schedule.step(schedule, task);
            Schedule.leap(schedule, task);
        }
    }
}
exports.run = run;
//# sourceMappingURL=schedule-run.js.map